const lang = {
  contact: 'Contacte',
  experience: 'Experiència',
  education: 'Educació',
  skills: 'Habilitats',
  about: 'Sobre mi'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/ca.js